import React, { useMemo } from 'react'

import { AIChatFallbackContactFragment } from 'types/graphql'

import { EllipsisButton } from 'src/components/EllipsisButton'
import { ActionItem } from 'src/govwell-ui/types'
import useDisclosure from 'src/hooks/use-disclosure'
import AIChatFallbackContactModal from 'src/pages/AIAssistantRoutingPage/AIChatFallbackContactModal'
import DeleteAIChatFallbackContactModal from 'src/pages/AIAssistantRoutingPage/DeleteAIChatFallbackContactModal'
import { RefetchFnType } from 'src/types'

type ButtonProps = {
  aiChatFallbackContact: AIChatFallbackContactFragment
  refetch: RefetchFnType
}

const AIChatFallbackContactButtons = (props: ButtonProps) => {
  const { aiChatFallbackContact, refetch } = props

  const editModalState = useDisclosure()
  const deleteModalState = useDisclosure()

  const items = useMemo(() => {
    const editItem: ActionItem = {
      label: 'Edit',
      key: `${aiChatFallbackContact.id}-edit`,
      icon: 'FaPencil',
      onClick: editModalState.open,
    }
    const deleteItem: ActionItem = {
      label: 'Delete',
      key: `${aiChatFallbackContact.id}-delete`,
      icon: 'FaTrash',
      onClick: deleteModalState.open,
    }
    return [editItem, deleteItem]
  }, [aiChatFallbackContact.id, editModalState, deleteModalState])

  return (
    <>
      <EllipsisButton items={items} />
      {editModalState.isOpen && (
        <AIChatFallbackContactModal
          aiChatFallbackContact={aiChatFallbackContact}
          onClose={editModalState.close}
          refetch={refetch}
        />
      )}
      {deleteModalState.isOpen && (
        <DeleteAIChatFallbackContactModal
          aiChatFallbackContact={aiChatFallbackContact}
          onClose={deleteModalState.close}
          refetch={refetch}
        />
      )}
    </>
  )
}

export default React.memo(AIChatFallbackContactButtons)
